<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('menu.menuitems.billing.subItems.reconciliation')"
    />
    <div class="row">
      <div class="col-6">
        <div>
          <div class="search-box chat-search-box w-50">
            <div class="position-relative">
              <input
                type="text"
                class="form-control fa-lg text-light"
                :placeholder="$t('billing_invoices.recons.search')"
                v-model="search"
                style="
                  background-color: #2a3042 !important;
                  width: 250px !important;
                "
              />
              <i class="bx bx-search-alt search-icon text-light"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 justify-content-end">
        <div>
          <button class="btn btn-light float-end mb-4" @click="DownloadFIle()">
            <span
              class="bx bxs-plus-circle float-end fa-2x"
              style="color: #2a3042 !important"
            ></span>
          </button>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="table-responsive">
          <table
            :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
            class="table table-centered table-nowrap table-striped table-hover align-middle"
          >
            <thead>
              <tr
                class="text-light"
                style="background-color: #2a3042 !important"
              >
                <th scop="col">#</th>
                <th scop="col">{{ $t("billing_invoices.recons.month") }}</th>
                <th scop="col">{{ $t("billing_invoices.recons.year") }}</th>
                <th scop="col">
                  {{ $t("billing_invoices.recons.refrence_number") }}
                </th>
                <th scop="col">
                  {{ $t("billing_invoices.recons.customers") }}
                </th>
                <th scop="col">{{ $t("billing_invoices.recons.amount") }}</th>
                <th scop="col">
                  {{ $t("billing_invoices.recons.operation") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, indx) in recons" :key="indx">
                <td>{{ (currentPage - 1) * perPage + indx + 1 }}</td>
                <td>{{ item.month }}</td>
                <td>{{ item.year }}</td>
                <td>{{ item.refrence_no }}</td>
                <td>{{ item.customer_count }}</td>
                <td>{{ parseFloat(item.amount_paid).toLocaleString() }}</td>
                <td>
                  <router-link
                    :to="{
                      name: 'Reconciliation_Details',
                      params: { id: item.id },
                    }"
                  >
                    <i
                      class="bx bx-info-circle fs-4 text-secondary"
                      style="cursor: pointer"
                      @click="console.log('wait')"
                    ></i>
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <BPagination
        :total-rows="rows"
        :per-page="perPage"
        v-model="currentPage"
      />
    </div>

    <!--Modal-->
  </Layout>
</template>
<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
export default {
  components: { Layout, PageHeader },
  data() {
    return {
      search: "",
      recons: [],
      currentPage: 1,
      perPage: 5,
      rows: 0,
      loading: false,
      existingSalaryMonthes: [],
      selectedMonth: "",
    };
  },
  watch: {
    search() {
      if (this.search.length > 0) this.RetriveInfo();
      else {
        this.currentPage = 1;
        this.RetriveInfo();
      }
    },
    currentPage() {
      this.RetriveInfo();
    },
  },
  methods: {
    getExistingSalaryMonthes() {
      this.http.get("billing-invoices/month").then((resp) => {
        if (resp.status) {
          const sorted = resp.data
            .map((m) => {
              const [year, month] = m.split("-").map(Number);
              return { year, month, str: m };
            })
            .sort((a, b) => a.year - b.year || a.month - b.month)
            .map((obj) => obj.str);

          // Add empty option at the top
          this.existingSalaryMonthes = ["", ...sorted];
        }
      });
    },
    RetriveInfo() {
      this.http
        .post("billing-invoices/recons", {
          query: this.search,
          page: this.currentPage,
          limit: this.perPage,
        })
        .then((res) => {
          this.recons = res.data;
          this.rows = res.tot;
        });
    },
    DownloadFIle() {
      var data = {
        title: "popups.addfile",
        inputs: [
          {
            model: "file",
            type: "file",
            label: this.$t("billing_invoices.recons.file"),
            restrictions: { required: true },
          },
          {
            model: "refrence_no",
            type: "number",
            label: this.$t("billing_invoices.recons.refrence_number"),
            restrictions: { required: true },
          },
          {
            model: "month",
            type: "select",
            label: this.$t("billing_invoices.recons.month"),
            options: this.existingSalaryMonthes.map((m) => ({
              value: m,
              label: m,
            })),
            value: "",
            restrictions: { required: true },
          },
        ],
        buttons: [
          {
            text: "popups.add",
            closer: true,
            color: "primary",
            handler: (obj) => {
              this.$loading.show();
              this.http
                .do("billing-invoices/download-file", obj)
                .then(() => {
                  this.getExistingSalaryMonthes();
                  this.RetriveInfo();
                })
                .catch(() => {
                  console.log("error");
                })
                .finally(() => {
                  this.loading = false;
                  this.$loading.hide();
                });
            },
          },
          {
            text: "popups.cancel",
            closer: true,
            color: "danger",
            handler: () => {
              console.log("Like Clicked");
            },
          },
        ],
      };
      this.popup.modal(data);
    },
  },
  mounted() {
    this.RetriveInfo();
    this.getExistingSalaryMonthes();
  },
};
</script>
<style></style>
